var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9261 4.16703L16.9581 8.17803L6.75211 18.331L2.72311 14.32L12.9261 4.16703ZM20.0171 3.20403L18.2171 1.41503C17.8818 1.08306 17.429 0.896851 16.9571 0.896851C16.4852 0.896851 16.0324 1.08306 15.6971 1.41503L13.9761 3.12503L18.0081 7.13603L20.0171 5.13603C20.1445 5.00945 20.2455 4.85894 20.3145 4.69315C20.3835 4.52737 20.419 4.34958 20.419 4.17003C20.419 3.99047 20.3835 3.81269 20.3145 3.6469C20.2455 3.48112 20.1445 3.33061 20.0171 3.20403ZM0.613105 19.957C0.596527 20.0329 0.599497 20.1117 0.621736 20.186C0.643975 20.2604 0.684754 20.3279 0.740243 20.3822C0.795731 20.4365 0.864108 20.4758 0.938951 20.4964C1.01379 20.517 1.09265 20.5183 1.16811 20.5L5.66111 19.416L1.63111 15.404L0.613105 19.957Z",
    fill: "#FF5023"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9261 4.16699L16.9581 8.17799L6.75211 18.332L2.72311 14.32L12.9261 4.16699ZM0.613105 19.957C0.596527 20.0328 0.599497 20.1116 0.621736 20.186C0.643975 20.2604 0.684754 20.3279 0.740243 20.3822C0.795731 20.4365 0.864108 20.4758 0.938951 20.4964C1.01379 20.517 1.09265 20.5182 1.16811 20.5L5.66111 19.416L1.63111 15.406L0.613105 19.957Z",
    fill: "#113956"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.fbb44abe89a430ca5319529c16467f8b.svg";
export { ForwardRef as ReactComponent };